import React, { FC } from 'react';

import { Clients } from '@ariksa/notification';
import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';

export const LearnMoreAboutJiraProjectSummaryPrefix: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="jira_project_summary_prefix"
      headerTitle="Jira Project – Summary Prefix"
      iconType={Clients.Jira}
      iconFilled={false}
      iconPadding={0}
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Summary prefix is text that automatically precedes the summary of
              the issue for which the ticket has been created. By having summary
              prefixes reflect, criteria associated with the workflow, you can
              easily categorize issues or group them to assign owners and route
              issues to accelerate response. Hub.
            </Text>
            <Text>
              For every ticket, Ariksa will automatically add a prefer to the
              ticket summary before the summary associated with the issue.
            </Text>
          </Stack>
        </Stack>
      }
    />
  );
};
